var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"errorpage"},[_c('center',[(!_vm.$route.params.fullData)?_c('section',{staticClass:"error_block"},[_c('img',{attrs:{"src":"https://miro.medium.com/max/1600/1*mUClow2WD0I2FIL_Iuzxfw.gif"}})]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }